import EmptyState from '@/components/EmptyState';
import SettingsSaveNav from '@/components/SettingsSaveNav';
import {
  WeeklyHoursEditor,
  useWeeklyHoursEditor,
} from '@/features/opening-hours/components/WeeklyHoursEditor';
import { useOpeningHours } from '@/features/opening-hours/hooks/useOpeningHours';
import { useT } from '@/i18n';
import { Block, BlockFooter, Navbar, Page, Preloader } from 'framework7-react';
import { useSettingsDetailBackLink } from '@/utils/useMediaQuery';

/**
 * The restaurant's BASE (general) opening hours - when it's physically open /
 * walk-in dine-in. Reservation, pickup and delivery follow these unless the
 * operator gives them their own custom hours in their settings group.
 */
export default function OpeningHoursPage() {
  const t = useT();
  const settingsBackLink = useSettingsDetailBackLink();
  const { data: rows, isLoading, isError } = useOpeningHours();
  const editor = useWeeklyHoursEditor('BASE', rows ?? []);

  return (
    <Page name="opening-hours">
      <Navbar title={t.openingHours.title} backLink={settingsBackLink}>
        {!isLoading && !isError && rows && (
          <SettingsSaveNav
            isDirty={editor.isDirty}
            saving={editor.isPending}
            onSave={editor.handleSave}
          />
        )}
      </Navbar>

      {isLoading && (
        <Block style={{ textAlign: 'center', marginTop: 40 }}>
          <Preloader />
        </Block>
      )}

      {!isLoading && (isError || !rows) && (
        <Block>
          <EmptyState
            icon="exclamationmark_triangle"
            title={t.openingHours.couldNotLoadHours}
            description={t.openingHours.checkConnection}
          />
        </Block>
      )}

      {!isLoading && !isError && rows && (
        <>
          <BlockFooter>{t.openingHours.generalHoursNote}</BlockFooter>

          <WeeklyHoursEditor editor={editor} />
        </>
      )}
    </Page>
  );
}
